export default "__VITE_ASSET__D2QjK$jG__"